module.exports = __webpack_public_path__ + "im.8c51fcfa4d1e40b1f76d.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/im.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/im.svg
// module chunks = styles